import React from 'react'

class DesignerPageNumber extends React.Component {
  constructor(props) {
    super(props)
    this.state = {value: this.props.page}

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(evt) {
    this.setState({value: evt.target.value})
    this.props.handlePageChange(evt.target.value)
  }

  render() {
    return (
      <div>
        <div className="d-flex flex-row p-2">
          <div className="d-flex flex-column">
            <a href="javascript:;" className="btn btn-primary" onClick={this.props.addPhotos}>Photos</a>
          </div>
        </div>
        <div className="d-flex flex-row px-3 pt-4">
          <div className="d-flex flex-column col-md-6 px-0 md-form">
            <label className="active">Page Number</label>
            <input type="number" value={this.state.value} onChange={this.handleChange} />
          </div>
        </div>
      </div>
    )
  }
}

export default DesignerPageNumber
